exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-icons .icon-wrapper[data-v-6ac30c0f] {\n  width: 30px;\n  border-radius: 8px;\n  height: 30px;\n  background-color: #e9f1fb;\n  color: #484848;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);

// exports
